import { FileUploadStatus } from '../lib/input-file/InputFile.enums';

export default {
    checkoutDeliveryOption: {
        headerLabel: 'Lieferoption',
        headerDescriptionLabel: 'Sollte SteelBuy alle Artikel an eine oder mehrere Adressen liefern?',
        singleAddressLabel: 'Einzeladresse',
        singleAddressDescriptionLabel: 'Ihre Bestellung wird an eine Adresse versendet.',
        multipleAddressLabel: 'Mehrere Adressen',
        multipleAddressDescriptionLabel: 'Ihre Bestellung wird an mehrere Adressen versendet.',
    },
    checkout: {
        delivery: {
            title: 'Lieferung',
            haulierRequiredMessage: 'Müssen wir für diesen Artikel einen Liefertermin buchen?',
            checkboxYes: 'Ja',
            checkboxNo: 'Nein',
            materialLocationLabel: 'Materialstandort',
        },
        deliveryText: 'Voraussichtliche Lieferzeit',
        payment: {
            optionCreditLabel: 'Kredit',
            optionCreditExplanation: 'Ihre Bestellung wird direkt versendet.',
            optionUpfrontLabel: 'Vorauszahlung',
            optionUpfrontExplanation: 'Ihre Bestellung wird versendet, nachdem wir Ihre Zahlung erhalten haben.',
        },
        shippingCostsLabel: 'Lieferung',
        totalExclVat: 'Gesamt (exkl. MwSt.)',
        total: 'Gesamt',
        itemsTotalExclVat: 'Artikel Gesamt (exkl. MwSt.)',
        itemsTotal: 'Artikel Gesamt',
        totalInclVat: 'Gesamt (inkl. MwSt.)',
        vatLabel: '+ {{value}}% MwSt',
        weight: 'Gewicht',
        theoreticalWeight: 'Theoretisches Gewicht',
    },
    dropdown: {
        deselectAll: 'Alle abwählen',
        selectAll: 'Alle auswählen',
        noOptions: 'Keine Optionen',
        filterPlaceholder: 'Suchen...',
    },
    fileInput: {
        showMoreLabel: 'Mehr anzeigen',
        showLessLabel: 'Weniger anzeigen',
        fileInputLabel: 'Bitte wählen Sie die Datei(en) zum Hochladen aus',
        filesUploaded: '{{uploadedCount}} von {{totalFiles}} hochgeladen',
        filesizeKB: '{{size}}KB',
        filesizeMB: '{{size}}MB',
        sizeAndStatus: '{{size}} - {{status}}',
        fileUploadStatus: {
            [FileUploadStatus.Uploading]: 'Hochladen',
            [FileUploadStatus.Error]: 'Fehler',
            [FileUploadStatus.Success]: 'Hochgeladen',
        },
        browse: 'Durchsuchen',
    },
    notification: {
        freightEstimate:
            'Der gelieferte Preis enthält eine geschätzte Frachtkostenberechnung; die endgültigen Frachtkosten können sich anpassen, sobald der Abholzeitpunkt mit dem Verkäufer bestätigt wurde.',
        freightQuoteUnavailable:
            'Frachtangebot nicht verfügbar. Bitte kontaktieren Sie SteelBuy, um ein Angebot anzufordern.',
    },
};
